app.service('compareProducts',function() {
	function init(){

	}
	return {
		init:init
	};
});
